import { getWindow } from "../getWindow"

const ssrWindow = getWindow()

/**
 * Finds the closest parent element that matches a selector.
 *
 * @param {Element} el - The element you want to start searching from.
 * @param {string} selector - The selector to match against.
 * @returns {Element|null} The closest parent element that matches the selector.
 */
function closest(el, selector) {
  let matchesFn

    // find vendor prefix
  ;[
    `matches`,
    `webkitMatchesSelector`,
    `mozMatchesSelector`,
    `msMatchesSelector`,
    `oMatchesSelector`,
  ].some((fn) => {
    if (typeof ssrWindow.document.body[fn] === `function`) {
      matchesFn = fn
      return true
    }
    return false
  })

  let parent

  // traverse parents
  while (el) {
    parent = el.parentElement
    if (parent && parent[matchesFn](selector)) {
      return parent
    }
    // eslint-disable-next-line no-param-reassign
    el = parent
  }

  return null
}

export default closest
